import { differenceInCalendarDays } from 'date-fns/differenceInCalendarDays';
import React from 'react';

import { getZonedDate } from '@eika-infrastruktur/date';
import { LinkPanel } from '@eika/link-panel';

import { formatDate } from '../../components/EFakturaList/EFakturaItem/getDueDateLabel';
import { Content } from '../../components/shared/Content';
import { useConfig } from '../../defaultConfig';
import useEfaktura from '../../fetchHooks/useEfaktura';
import useTranslation from '../../hooks/useTranslation';
import FuturePaymentEfakturaSkeleton from './FuturePaymentEfakturaSkeleton';

import './FuturePaymentsEfaktura.scss';

const today = getZonedDate();
const FuturePaymentsEFaktura: React.FC = () => {
    const { approvalListLink } = useConfig();
    const translated = useTranslation();
    const { data: eFakturas, ...efakturaState } = useEfaktura();

    const getDeadlineText = (): string => {
        if (!eFakturas || eFakturas.length < 1) return '';
        const firstEfaktura = eFakturas[0];
        const date = getZonedDate(firstEfaktura.paymentDate);
        const numberOfDays = differenceInCalendarDays(date, today);
        const { futurePaymentsEFaktura } = translated;
        const first = eFakturas.length > 1 ? futurePaymentsEFaktura.theFirst : futurePaymentsEFaktura.it;
        if (numberOfDays === 0) {
            return `${first} ${futurePaymentsEFaktura.hasDeadlineToday}`;
        }
        if (numberOfDays === 1) {
            return `${first} ${futurePaymentsEFaktura.hasDeadlineTomorrow}`;
        }
        if (numberOfDays > 0 && numberOfDays < 7) {
            return `${first} ${futurePaymentsEFaktura.hasDeadlineOn} ${date.toLocaleDateString('no', {
                weekday: 'long',
            })}`;
        }
        if (numberOfDays > 0) {
            return `${first} ${futurePaymentsEFaktura.hasDeadline} ${formatDate(date)}`;
        }
        if (numberOfDays === -1) {
            return `${first} ${futurePaymentsEFaktura.hadDeadlineYesterday}`;
        }
        if (numberOfDays < 0 && numberOfDays > -7) {
            return `${first} ${futurePaymentsEFaktura.hadDeadlineLast} ${date.toLocaleDateString('no', {
                weekday: 'long',
            })}`;
        }
        return `${first} ${futurePaymentsEFaktura.hadDeadline} ${formatDate(date)}`;
    };

    if (efakturaState.isLoading) {
        return <FuturePaymentEfakturaSkeleton />;
    }

    if (!approvalListLink || !eFakturas || eFakturas.length < 1) {
        return null;
    }

    const eFakturaTekst = `${translated.futurePaymentsEFaktura.youHave} ${eFakturas.length} ${
        eFakturas.length > 1
            ? translated.futurePaymentsEFaktura.newPlural
            : translated.futurePaymentsEFaktura.newSingular
    } ${translated.eFaktura.eFaktura}`;

    return (
        <Content className="future-payments-efaktura">
            <LinkPanel
                title={eFakturaTekst}
                url={approvalListLink.url}
                textTwo={getDeadlineText()}
                ariaLabel={eFakturaTekst}
            />
        </Content>
    );
};

export default FuturePaymentsEFaktura;
